import {validApplicationTypeGuard} from './abstract-application.guard';

export const validBusinessOverdraftGuard = () => {
  return validApplicationTypeGuard('BusinessOverdraft', 'e-not-business');
}
